<template>
  <VView class="gallery" back-button-to="/menu" :header="$t('gallery.header')" is-slider :slide-index="$store.state.gallerySlideIndex" @slideChange="onSlideChange($event)">
    <ul class="gallery__grid" v-for="(page, pageIndex) in pages" :key="pageIndex">
      <li class="gallery__item" v-for="(entry, entryIndex) in page" :key="entryIndex">
        <VMedia class="gallery__frame">
          <img :src="entry.result.attachment" @click="selectEntry(entry)" />
        </VMedia>

        <VText center>{{ entry.firstName }}</VText>
      </li>
    </ul>
  </VView>
</template>

<script>
import VText from '@/components/VText.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';
import VView from '@/components/VView.vue';
import VMedia from '@/components/VMedia.vue';
import { SET_GALLERY_SLIDE_INDEX } from '@/store';

const ITEMS_PER_PAGE = 9;

export default {
  name: 'Gallery',
  components: {
    VView,
    VText,
    VMedia,
    VButton,
    VButtonGroup,
  },

  data: () => ({
    entries: [],
    pages: [],
  }),

  async mounted() {
    const { data: entries } = await this.$bricodes.getPublicEntries();

    //this.entries = entries.filter(entry => entry.isConfirmed).reverse();
    this.entries = entries.filter(entry => entry.isConfirmed).reverse();
    this.pages = this.entries.map((e, i) => {
      return i % ITEMS_PER_PAGE === 0 ? this.entries.slice(i, i + ITEMS_PER_PAGE) : null;
    }).filter(e => !!e);
  },

  methods: {
    selectEntry(entry) {
      this.$router.push(`/gallery-item?url=${entry.result.attachment}`);
    },

    onSlideChange(gallerySlideIndex) {
      this.$store.commit(SET_GALLERY_SLIDE_INDEX, {
        gallerySlideIndex,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery {
  &__grid {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &__item {
    flex: 1 1 33.3333%;
    max-width: 33.3333%;
    padding: 13px 18px;

    @media screen and (max-width: 800px) {
      flex: 1 1 50%;
      max-width: 50%;
    }

    @media screen and (max-width: 550px) {
      flex: 1 1 100%;
      max-width: 100%;
    }

    ::v-deep .text {
      margin-top: 0;
      font-size: 20px;
      line-height: 1.25em;
    }
  }

  &__frame {
    cursor: pointer;
  }
}
</style>
